const breakpoint = {
  sp: 768 - 1,
  tab: 1080 - 1,
};

const getMediaquery = (key: 'sp' | 'tab' = 'sp'): string => {
  return `@media (max-width: ${breakpoint[key]}px)`;
};

export default getMediaquery;
